import SelectionStatus from './SelectionStatus';
import './SelectionStatus.scss';

export default SelectionStatus;